import React from 'react';

type FigablLogoProps = {
  className?: string;
};

/**
 * The Figabl wordmark, inlined so it picks up the Roboto webfont the app
 * already loads. As an <img> it would fall back to a system sans-serif on
 * machines without Roboto installed.
 */
const FigablLogo = ({ className }: FigablLogoProps) => (
  <svg
    viewBox="0 0 400 200"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Figabl"
    className={className}
  >
    <g
      fill="currentColor"
      fontFamily="Roboto, sans-serif"
      fontSize="160"
      fontWeight="300"
      transform="translate(34, 6)"
    >
      <text x="0" y="148" letterSpacing="-0.8">f</text>
      <text x="53" y="149" letterSpacing="-10.3">i</text>
      <text x="74" y="149" letterSpacing="-10.3">g</text>
      <text x="153" y="149" letterSpacing="-10.3">abl</text>
    </g>
  </svg>
);

export default FigablLogo;
